module.exports = __webpack_public_path__ + "static/img/jc.d0289dc0.png";